import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'react-emotion';

import DetailBodyLocation from './DetailBodyLocation/DetailBodyLocation';
import { getInnerHTMLFormat } from '../../../helpers/utils';
import { Group, H3, Paragraph } from '../../../components/Text/Text';
import Style from '../../../styles/common';

const Container = styled('div')`
  background-color: ${Style.color.contentBackground};
  display: flex;
  flex-grow: 1;
  justify-content: center;
`;

const Content = styled('div')`
  display: flex;
  max-width: 900px;
  width: ${Style.size.width.detailContentWidth};
`;

const Sidebar = styled('aside')`
  min-width: ${Style.size.width.poster};
`;

const ContentText = styled('div')`
  margin: 3rem;
`;

function DetailBody(props) {
  const dateString = getDate(
    props.startDateTime,
    props.endDateTime,
    props.allDay
  );

  return (
    <Container>
      <Content>
        <Sidebar />
        <ContentText>
          <Group>
            <H3>Date & Time</H3>
            <Paragraph>{dateString}</Paragraph>
          </Group>
          <DetailBodyLocation location={props.location} />
          <Group>
            <H3>Description</H3>
            <Paragraph {...getInnerHTMLFormat(props.description)} />
          </Group>
        </ContentText>
      </Content>
    </Container>
  );
}

function getDate(start, end, allDay) {
  const momentStart = moment.unix(start);
  const momentEnd = moment.unix(end);

  const isSameDay = momentStart.date() === momentEnd.date();
  const startDate = momentStart.format('dddd, MMMM D, YYYY');
  const startTime = momentStart.format('h:mm a');
  const endDate = momentEnd.format('dddd, MMMM D, YYYY');
  const endTime = momentEnd.format('h:mm a');

  if (isSameDay) {
    if (allDay) {
      return startDate;
    } else {
      return `${startDate}, ${startTime} to ${endTime}`;
    }
  } else {
    if (allDay) {
      return `${startDate} to ${endDate}`;
    } else {
      return `${startDate} to ${endDate}, ${startTime} to ${endTime}`;
    }
  }
}

DetailBody.propTypes = {
  allDay: PropTypes.bool.isRequired,
  description: PropTypes.string.isRequired,
  endDateTime: PropTypes.number.isRequired,
  location: PropTypes.string.isRequired,
  startDateTime: PropTypes.number.isRequired,
};

DetailBody.defaultProps = {
  allDay: false,
  description: '',
  endDateTime: '',
  location: '',
  startDateTime: '',
};

export default DetailBody;



// WEBPACK FOOTER //
// ./src/views/Detail/DetailBody/DetailBody.js